import Swiper from 'swiper/bundle';

export default () => {
  const swiper = new Swiper('.full-slider', {
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 500,
    slidesPerView: 1,
    loop: true,
    grabCursor: true,
    
    pagination: {
      el: '.full-slider__pagination',
      clickable: true,
    },
  })
}